import { lazy, Suspense } from "react"
import { Redirect, Route, Switch } from "react-router-dom"
import LoadingScreen from "src/components/Common/LoadingScreen"
import DashboardLayout from "src/layouts/DashboardLayout"
import ConfigIndex from "./parking/Settings/ConfigIndex"

const Parking = lazy(() => import("./parking"))
const BitacorasParking = lazy(() => import("./parking/Bitacora/index"))
const PagosParking = lazy(() => import("./parking/Pagos/index"))
const NotFoundView = lazy(() => import("../errors/NotFoundView"))

const Guardia = ({ match }) => (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        <Redirect
          exact
          from={`${match.url}/`}
          to={`${match.url}/parqueadero`}
        />
        <Route
          path={`${match.url}/parqueadero`}
          render={props => <Parking {...props} />}
        />
        <Route
          path={`${match.url}/bitacoraParkey`}
          render={props => <BitacorasParking {...props} />}
        />
        <Route
          path={`${match.url}/pagosParkey`}
          render={props => <PagosParking {...props} />}
        />
        <Route
          path={`${match.url}/configParkey`}
          render={props => <ConfigIndex {...props} />}
        />
        <Route render={props => <NotFoundView {...props} />} />
      </Switch>
    </Suspense>
  </DashboardLayout>
)

export default Guardia
